import type { SelectChangeEvent } from "@mui/material";
import { Grid, Select, Stack, Typography } from "@mui/material";
import type { MeasureDateRange } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import type { LinePeriodOption, LinePeriodValue } from "../utils/statementOptions.ts";
import { INHERIT_PERIOD } from "../utils/statementOptions.ts";

interface Props {
  dateRange: MeasureDateRange | undefined;
  options: LinePeriodOption[];
  note: string;
  readonly: boolean;
  onChange: (dateRange: MeasureDateRange | undefined) => void;
}

const PeriodSelect = ({ dateRange, options, note, readonly, onChange }: Props) => {
  const handleChange = (event: SelectChangeEvent<LinePeriodValue>) => {
    const option = options.find((candidate) => candidate.value === event.target.value);
    if (option) {
      onChange(option.value === INHERIT_PERIOD ? undefined : option.value);
    }
  };

  return (
    <Stack spacing={0.75} useFlexGap>
      <Grid container sx={{ alignItems: "center", width: "100%" }}>
        <Typography>Period</Typography>
        <HorizontalFill />
        <Select<LinePeriodValue>
          value={dateRange ?? INHERIT_PERIOD}
          onChange={handleChange}
          disabled={readonly}
          sx={{ width: 208, ".MuiSelect-select": { py: 0.7, alignContent: "center" } }}
        >
          {options.map((option) => (
            <MenuItemStyled key={option.value} value={option.value}>
              <Typography variant="caption">{option.label}</Typography>
            </MenuItemStyled>
          ))}
        </Select>
      </Grid>
      <Typography variant="caption" color="textSecondary">
        {note}
      </Typography>
    </Stack>
  );
};

export default PeriodSelect;
